import { Typography } from '@mui/material';
import { useMemo } from 'react';
import { ITableColumn, TableList } from 'src/components/table';
import { AFOPUHeader, AFOPURow } from '../hooks/useTablaValorAFOPU';
import { OperacionAFOPUTablaValorFields } from '../types/fields';

interface AFOPUTablaValoresProps {
  headers: AFOPUHeader[],
  rows: AFOPURow[],
  loading?: boolean,
  error: any

}

const AFOPUTablaValores = ({ headers, rows, loading = false, error }: AFOPUTablaValoresProps) => {

  const columns: ITableColumn[] = useMemo(() => {
    const cols: ITableColumn[] = [
      {
        label: 'Instrumento',
        onRenderCell: (row: AFOPURow) => (
          <Typography variant="body2" fontWeight="bold">
            {row.descInstrumento}
          </Typography>
        )
      }
    ];

    headers.forEach((header) => {
      cols.push({
        label: header.descOperacionTipo,
        onRenderCell: (row: AFOPURow) => {
          const celda = row.celdas[header.codOperacionTipo];

          if (!celda) return <span>-</span>;

          const valor = celda[OperacionAFOPUTablaValorFields.Valor];

          return (
            <Typography
              variant="body2"
              sx={{
                color: valor === 'No Aplica' ? 'text.disabled' : 'text.primary',
                fontStyle: valor === 'No Aplica' ? 'italic' : 'normal'
              }}
            >
              {valor}
            </Typography>
          );
        }
      });
    });

    return cols;
  }, [headers]);

  return (
    <TableList
      entityList={rows}
      columns={columns}
      isLoading={loading}
      error={error?.message}
    />
  )
}

export default AFOPUTablaValores